import { Container, Sprite, Text, TextStyle } from "pixi.js";
import { GameFont } from "../../../common/GameFont";
import { INewsModel } from "../../../game/models/INewsModel";
import { CheckoutsTooltipResourcePackage } from "../../../common/resources/CheckoutsTooltipResourcePackage";

export class CheckOutFixUpgradeTooltip extends Container {
    public constructor(
        checkoutsTooltipResources: CheckoutsTooltipResourcePackage,
        newsModel: INewsModel
    ) {
        super();
        const background = new Sprite(checkoutsTooltipResources.assets_views_checkouts_tooltip_tooltip_base_variant3_png);
        background.width = 562;
        background.height = 377;
        background.anchor.set(0.5);
        this.addChild(background);
        const tooltipUnion = new Sprite(checkoutsTooltipResources.assets_views_checkouts_tooltip_tooltip_union_variant1_png);
        tooltipUnion.width = 562;
        tooltipUnion.height = 225;
        tooltipUnion.anchor.set(0.5);
        tooltipUnion.scale.x *= -1;
        this.addChild(tooltipUnion);
        tooltipUnion.position.y = 133;
        const tooltipText = new Text(`${newsModel.news.value.guest.firstName.toUpperCase()}\nRAIDED YOUR BUILDING,\nGO TO FIX IT HERE`, new TooltipTextStyle());
        tooltipText.anchor.set(0.5);
        this.addChild(tooltipText);
    }
}

class TooltipTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            fill: "#ffffff",
            align: "center",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 64,
            lineHeight: 73
        }));
    }
}
